<template>
	<div class="wrap-package userKhaosodCoins">
		<div class="my-coins">
			<span class="mif-coins"></span>
			<span
				>{{ $t('KhaosodCoins.myThaiRaithCoins') }} :
				{{ profileUser.coin }}</span
			>
		</div>
		<div v-for="coinpakcage in coinPackages" v-bind:key="coinpakcage.id">
			<div
				class="package-item"
				:style="{
					border: '1px solid' + coinpakcage.primary_color,
					background: coinpakcage.secondary_color
				}"
				@click="isMobile?mobileChoosePackage(coinpakcage.id):gotoPayment(coinpakcage.id)"
				v-bind:class="{ active: packageActive == coinpakcage.id }"
			>
				<div class="active-circle"></div>
				<div
					class="great-value"
					v-if="coinpakcage.label !== null && coinpakcage.label !== ''"
				>
					{{ coinpakcage.label }}
				</div>
				<div
					class="package-name"
					:style="{ background: coinpakcage.primary_color }"
				>
					{{ coinpakcage.name }}
				</div>
				<div class="price">
					{{ coinpakcage.coins.toLocaleString() }}
					<div class="text">
						{{ $t('payment.methods.khaosodCoin.title') }}
					</div>
				</div>
				<div class="coins">
					{{ coinpakcage.price.toLocaleString() }}
					<div class="text">{{ $t('baht') }}</div>
				</div>
				<div class="buy">
					<b-button
						class="btn-buy"
						:style="{ background: coinpakcage.primary_color }"
						>{{ $t('payment.methods.select') }}</b-button
					>
				</div>
			</div>
		</div>

		<div class="mb-buy">
			<b-button class="btn-buy success-button" @click="gotoPayment(packageActive)">{{ $t('payment.methods.mobileSelect') }}</b-button>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';


export default {
	components: {
	},
	props: {
		previousPendingPaymentId: {
			required: false,
			defaul: null
		}
	},
	data() {
		return {
			packageActive: null,
			loading: false,
			profileUser: localStorage.getItem('user_profile')
				? JSON.parse(localStorage.getItem('user_profile'))
				: 0
		};
	},
	methods: {
		...mapActions('PackageController', ['GET_COIN_PACKAGES']),
		...mapActions('PaymentController', ['MAKE_PAYMENT_FOR_COIN_PACKAGE']),
		mobileChoosePackage(num) {
			
			var vm = this;
			if(vm.loading){
				return;
			}
			vm.loading = true;
			this.packageActive = num;
			if(!this.isMobile){
				this.gotoPayment(this.packageActive)
			}else{
				vm.loading = false;
			}
		},
		gotoPayment(item){
			var vm = this;
			this.MAKE_PAYMENT_FOR_COIN_PACKAGE({
				packages: [],
				general_packages: [item]
			}).then(data => {
				if (data.data.id) {
					setTimeout(() => {
						vm.loading = false;
						this.$router.push({
							name: 'Payment',
							params: {
								previousPendingPaymentId: parseInt(vm.previousPendingPaymentId),
								id: data.data.id
							}
						});
					}, 500);
				}
			});
		}
	},
	mounted() {
		this.GET_COIN_PACKAGES({
			take: 10,
			page: 1
		});
	},
	watch: {
		previousPendingPaymentId: function(previousPendingPaymentId) {
			this.boxTwo = '';
			this.$bvModal
				.msgBoxOk('Your going to redirect to previous order screen', {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					headerClass: 'p-2 border-bottom-0',
					footerClass: 'p-2 border-top-0',
					centered: true
				})
				.then(value => {
					this.boxTwo = value;
					if (previousPendingPaymentId && value) {
						this.$router.push(
							this.$i18nRoute({ name: 'payment' }, previousPendingPaymentId)
						);
					}
				})
				.catch(err => {
					// An error occurred
				});
		}
	},
	computed: {
		...mapGetters('UserController', ['isMobile']),
		...mapState('PackageController', ['coinPackages'])
	}
};
</script>
<style lang="scss">
@import 'userKhaosodCoins.scss';
</style>
